import { FunctionComponent } from "react";
import PricingContainer from "../../components/website/prices/PricingContainer";
import TopNav from "../../components/navigation/TopNav";
import MobileNav from "../../components/navigation/MobileNav";
import Contact from "../../components/website/Contact";
import Footer from "../../components/website/Footer";
import PriceHeader from "../../components/website/prices/PriceHeader";
import SoftwareFeatures from "../../components/website/landing/SoftwareFeatures";

const B2CTiers: FunctionComponent = () => (
  <div className="max-w-[1440px] mx-auto w-full">
    <TopNav />
    <MobileNav />
    <PriceHeader />
    <PricingContainer audience="b2c" />
    <Contact />
    <Footer />
  </div>
);

export default B2CTiers;
